(function () {
  const nextSiblings = (currentElement) => {
    let next_siblings = [];
    let sibling = currentElement.nextElementSibling;

    while (sibling) {
      next_siblings.push(sibling);
      sibling = sibling.nextElementSibling;
    }

    return next_siblings;
  };

  const footerDifferenceCalc = () => {
    if (
      window.innerWidth > 989 &&
      document.querySelector(".home_page_slider .footer--center_subscribe") !==
        null
    ) {
      const innerBlock = document.querySelector(
        ".home_page_slider .footer--center_subscribe"
      );
      const sectionBlock = document.querySelector(
        ".shopify-section-group-footer-group"
      );

      if (!innerBlock || !sectionBlock) return;

      const innerHeight = innerBlock.offsetHeight;
      const sectionHeight = sectionBlock.offsetHeight;

      innerBlock.querySelector(
        ".footer--newsletter__form--center"
      ).style.marginTop = `${0 - (innerHeight - sectionHeight)}px`;
    }
  };

  const calculateNewsletterMargin = () => {
    return new Promise((resolve) => {
      const timeout =
        document.querySelector(".home_page_slider") !== null ? 700 : 0;

      setTimeout(() => {
        const footerNewsletter = document.querySelector(
          ".footer--newsletter__form--center"
        );

        if (footerNewsletter) {
          // FIX: reset inline styles to prevent compounding from a prev calc-s
          footerNewsletter.style.paddingTop = "";
          footerNewsletter.style.marginTop = "";

          const footerParent = footerNewsletter.parentNode;
          const footerStyles = window.getComputedStyle(footerParent);

          const footerPaddingTop =
            parseInt(footerStyles.getPropertyValue("padding-top"), 10) || 0;
          const nextSiblingsTotalHeight = nextSiblings(footerNewsletter).reduce(
            (totalHeight, sibling) => {
              const siblingHeight = sibling.offsetHeight || 0;
              return totalHeight + siblingHeight;
            },
            0
          );
          const siblingsTotalHeight =
            nextSiblingsTotalHeight - footerPaddingTop;

          // FIX: outerHeight also includes height of browser window (tabs, URL bar etc)
          const windowHeight = window.innerHeight;
          const newsletterHeight = footerNewsletter.offsetHeight;

          const spaceLeftTotal =
            windowHeight - siblingsTotalHeight - newsletterHeight;
          const spaceLeftAbove = spaceLeftTotal / 2;

          footerNewsletter.style.paddingTop = `${Math.max(
            spaceLeftAbove,
            0
          )}px`;
        }

        resolve(); // Signal completion
      }, timeout);
    });
  };

  const displayPaddingAndMargin = () => {
    const footerNewsletter = document.querySelector(
      ".footer--newsletter__form--center"
    );
  };

  const footer = async () => {
    if (document.querySelector(".footer--newsletter__form--center") != null) {
      calculateNewsletterMargin()
        .then(footerDifferenceCalc)
        .then(displayPaddingAndMargin);
    }
  };

  document.addEventListener("shopify:section:load", footer);
  footer();

  window.addEventListener("resize", () => {
    setTimeout(footer, 1000);
  });
})();
